export default __webpack_public_path__ + "static/media/IC00045-profile.ef776c72.svg";